<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close"></div>
        <div class="loadingFull" v-if="loadingFull"></div>
        <div class="finished" v-if="finished">
          <div>
            <img src="../assets/sent.png">
            <h4>Form Submitted</h4>
            <p>Terima kasih telah mengisi Saran dan Masukan<br />mengenai BodyKey
              Challenge.</p>
            <button class="btn btnSecondary" v-on:click="close(true)">Close</button>
          </div>
        </div>
        <h4 v-if="state === 5">Testimonial Sharing</h4>
        <h4 v-else>Saran dan Masukan</h4>
        <p v-if="state === 5">Silahkan share testimonial kamu selama mengikuti
          challenge ini. Contohnya: Perubahan gaya hidup yang didapatkan,
          pengurangan berat dan lingkar pinggang, dan cerita seru lainnya</p>
        <p v-if="state === 6">Untuk challenge berikutnya, apabila Bapak/Ibu
          kembali ikut dan jadi Finisher, hadiah apa yang diharapkan</p>
        <p v-else>Berikan saran dan masukan untuk BodyKey Challenge dari pengalaman kamu
          selama mengikuti challenge ini.</p>
        <div class="fieldGroup" :class="{hasError: happyError}" v-if="state === 0">
          <label>Apakah kamu senang dengan aktivitas di BK Challenge?</label>
          <div class="happyCnt">
            <div class="happyItem" v-for="(item, i) in happyItems" :key="`h${i}`"
              :class="{blink: item.blink, selected: item.selected}"
              v-on:click="selectHappy(i, item)">
              <div class="happyIcon" :class="item.class"></div>
              <h4>{{item.label}}</h4>
            </div>
          </div>
          <div class="fieldError" v-if="happyError">Mohon pilih seberapa senang kamu
            dengan aktifitas di BK Challenge</div>
        </div>
        <div class="fieldGroup" v-else-if="state === 1">
          <label>Bagian mana yang kamu suka di BK Challenge?</label>
          <textarea class="field" rows="3" v-model="form.partLiked.model"
            placeholder="Tulis jawaban kamu disini..."></textarea>
        </div>
        <div class="fieldGroup" v-else-if="state === 2">
          <label>Bagian mana yang menurut kamu dapat dibuat
            lebih baik di BK Challenge?</label>
          <textarea class="field" rows="3" v-model="form.partImproved.model"
            placeholder="Tulis jawaban kamu disini..."></textarea>
        </div>
        <div class="fieldGroup" v-else-if="state === 3">
          <label>Apakah kamu dapat mengakses semua kegiatan di
            BK Challenge dengan mudah?</label>
          <div class="happyCnt">
            <div class="happyItem" v-for="(item, i) in starItems" :key="`h${i}`"
              :class="{blink: item.blink, selected: item.selected}"
              v-on:click="selectStar(i, item)">
              <div class="happyIcon" :class="item.class"></div>
              <h4>{{item.label}}</h4>
            </div>
          </div>
        </div>
        <div class="fieldGroup" v-else-if="state === 4">
          <label>Masukan untuk BK Challenge</label>
          <textarea class="field" rows="3" v-model="form.feedback.model"
            placeholder="Tulis jawaban kamu disini..."></textarea>
        </div>
        <div class="fieldGroup" v-else-if="state === 5">
          <label v-if="1>2">Testimonial dari kamu untuk BK Challenge /
          Caption untuk foto before after</label>
          <textarea class="field" rows="3" v-model="form.testimoni.model"
            placeholder="Tulis jawaban kamu disini..."></textarea>
          <div class="hint">Disclaimer: Testimonial ini dapat digunakan
            oleh tim Amway Indonesia untuk publikasi</div>
        </div>
        <div class="fieldGroup" v-else-if="state === 6">
          <div class="prizeOptions">
            <div class="prizeOption" :class="{selected: form.prize.model === 'jersey'}"
              v-on:click="form.prize.model = 'jersey'">
              <div class="checkbox"></div> Kaos Jersey</div>
            <div class="prizeOption" :class="{selected: form.prize.model === 'other'}"
              v-on:click="form.prize.model = 'other'">
              <div class="checkbox"></div>
              Lainnya</div>
          </div>
          <template v-if="form.prize.model === 'other'">
            <textarea class="field" rows="3" v-model="form.prizeOther.model"
              placeholder="Lainnya tolong isi di sini..."></textarea>
          </template>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" v-on:click="goBack"
            v-if="!loading">
            <span v-if="state === 0">Batal</span>
            <span v-else>Sebelumnya</span>
          </button>
          <button class="btn btnPrimary" :class="{btnLoading: loading}"
            v-on:click="handleSubmit">
            <span v-if="state === 6">Submit</span>
            <span v-else>Berikutnya</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      loading: false,
      loadingFull: true,
      state: 0,
      happyError: false,
      finished: false,
      happyItems: [
        {
          label: 'Kecewa Sekali',
          class: 'veryDisappointed',
          selected: false,
          blink: false,
        },
        {
          label: 'Kecewa',
          class: 'disappointed',
          selected: false,
          blink: false,
        },
        {
          label: 'Biasa Saja',
          class: 'moderate',
          selected: false,
          blink: false,
        },
        {
          label: 'Senang',
          class: 'happy',
          selected: false,
          blink: false,
        },
        {
          label: 'Senang Sekali',
          class: 'veryHappy',
          selected: false,
          blink: false,
        },
      ],
      starItems: [
        {
          label: 'Sangat Susah',
          class: 'veryDisappointed',
          selected: false,
          blink: false,
        },
        {
          label: 'Susah',
          class: 'disappointed',
          selected: false,
          blink: false,
        },
        {
          label: 'Biasa Saja',
          class: 'moderate',
          selected: false,
          blink: false,
        },
        {
          label: 'Mudah',
          class: 'happy',
          selected: false,
          blink: false,
        },
        {
          label: 'Sangat Mudah',
          class: 'veryHappy',
          selected: false,
          blink: false,
        },
      ],
      form: {
        isHappy: { model: 0 },
        canAccess: { model: 0 },
        partLiked: { model: '', error: null },
        partImproved: { model: '', error: null },
        difficulty: { model: '', error: null },
        feedback: { model: '', error: null },
        testimoni: { model: '', error: null },
        prize: { model: 'jersey' },
        prizeOther: { model: '' },
      },
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      this.loadingFull = true;
      this.state = 0;
      this.$http.get(this.$config.uri('user/testimoni')).then((r) => {
        if (r.data.status === 200) {
          const { data } = r.data;
          this.form.isHappy.model = data.isHappy;
          this.form.canAccess.model = data.canAccess;
          this.form.partLiked.model = data.partLiked;
          this.form.partImproved.model = data.partImproved;
          this.form.difficulty.model = data.difficulty;
          this.form.feedback.model = data.feedback;
          this.form.testimoni.model = data.testimoni;
          this.form.prize.model = data.prize;
          this.form.prizeOther.model = data.prizeOther;
        } else {
          this.form.isHappy.model = 0;
          this.form.canAccess.model = 0;
          this.form.partLiked.model = '';
          this.form.partImproved.model = '';
          this.form.difficulty.model = '';
          this.form.feedback.model = '';
          this.form.testimoni.model = '';
          this.form.prize.model = 'jersey';
          this.form.prizeOther.model = '';
        }
        this.loadingFull = false;
      });
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    selectHappy(i, item) {
      // eslint-disable-next-line
      for (const h of this.happyItems) {
        h.selected = false;
        h.blink = false;
      }
      this.happyItems[i].selected = true;
      this.happyItems[i].blink = true;
      this.form.isHappy.model = i + 1;
    },
    selectStar(i, item) {
      // let i2 = 0;
      // eslint-disable-next-line
      for (const h of this.starItems) {
        // h.selected = (i2 <= i);
        h.selected = false;
        h.blink = false;
        // i2 += 1;
      }
      this.starItems[i].selected = true;
      this.starItems[i].blink = true;
      this.form.canAccess.model = i + 1;
    },
    goBack() {
      if (this.state === 0) {
        this.close(false);
        return;
      }
      this.state -= 1;
    },
    handleSubmit() {
      if (this.state >= 6) {
        this.loading = true;
        this.$http.post(this.$config.uri('user/testimoni'), this.form).then((r) => {
          this.finished = true;
        });
        return;
      }
      this.state += 1;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes blink {
  0% { background-color: transparent; }
  25% { background-color: #ffe8bf; }
  50% { background-color: transparent; }
  75% { background-color: #ffe8bf; }
  100% { background-color: transparent; }
}

.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    background-color: #fbffc9;
    z-index: 2;
    padding: 30px 40px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    max-width: 640px;
    // background-image: url(../assets/high-five.png);
    background-size: 180px auto;
    background-position: left bottom;
    background-repeat: no-repeat;
    .finished{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #fbffc9;
      z-index: 991;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      text-align: center;
      padding: 0 60px;
      img{
        width: 68px;
        margin: 0 0 20px;
      }
      h4{
        font-size: 24px;
        margin: 0 0 14px;
      }
      p{
        margin: 0 0 10px;
        max-width: 560px;
      }
      button{
        padding: 12px 40px 12px;
        margin-top: 10px;
      }
    }
    .loadingFull{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      border-radius: 5px;
      background-color: #fbffc9;
      background-image: url(../assets/loading.svg);
      background-size: 46px auto;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 991;
    }
    .close{
      width: 36px; height: 36px;
      border-radius: 50%;
      position: absolute;
      right: 10px; top: 10px;
      background-image: url(../assets/close.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .7;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: rgba(0,0,0,.2);
        opacity: .6;
      }
    }
    @media (max-width: 680px) {
      width: calc(100% - 20px);
      box-sizing: border-box;
      padding: 40px 30px 30px;
    }
    &.hasCheck{
      text-align: left;
    }
    .prizeOptions{
      .prizeOption{
        padding: 10px;
        margin: 0 0 5px;
        font-weight: 600;
        font-size: 18px;
        border: #999 1px solid;
        border-radius: 5px;
        padding-left: 46px;
        position: relative;
        .checkbox{
          width: 20px; height: 20px;
          position: absolute;
          left: 14px; top: 50%;
          margin-top: -10px;
          box-sizing: border-box;
          border-radius: 50%;
          border: #999 2px solid;
        }
        &:hover{
          border-color: #222;
          transition: all .3s ease;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          cursor: pointer;
          .checkbox{
            border-color: #222;
          }
        }
        &.selected{
          .checkbox{
            border-color: #006519;
            &:before{
              content: "";
              position: absolute;
              background-color: #006519;
              top: 2px; right: 2px; bottom: 2px; left: 2px;
              border-radius: 50%;
            }
          }
        }
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 24px;
      font-weight: normal;
      color: #444;
      @media (max-width: 680px) {
        font-size: 22px;
        margin-bottom: 6px;
      }
    }
    p{
      margin: 0 0 12px;
      color: #767676;
      color: #444;
      @media (max-width: 680px) {
        font-size: 15px;
      }
    }
    .fieldGroup{
      padding: 20px 0 40px;
      margin: 0;
      @media (max-width: 680px) {
        padding: 6px 0 20px;
      }
      label{
        font-size: 20px;
        font-weight: 600;
        color: #444;
        text-transform: none;
        margin: 0 0 10px;
        @media (max-width: 680px) {
          font-size: 16px;
        }
      }
      .hint{
        padding: 6px 0 4px;
        border-radius: 50px;
        margin: 0;
        backdrop-filter: blur(16px);
        font-size: 14px;
        color: #444;
        font-style: italic;
        @media (max-width: 680px) {
          font-size: 13px;
          line-height: 1.2;
        }
      }
      .happyCnt{
        display: flex;
        justify-content: space-between;
        .happyItem{
          width: calc(20% - 10px);
          text-align: center;
          margin: 10px 0 0;
          padding: 14px 0;
          border-radius: 10px;
          // background-color: #fbffc9;
          backdrop-filter: blur(20px);
          cursor: pointer;
          border: transparent 1px solid;
          box-sizing: border-box;
          @media (max-width: 680px) {
            width: calc(20% - 5px);
            margin: 0;
            padding: 6px 0;
            border-radius: 5px;
          }
          .happyIcon{
            width: 46px; height: 46px;
            margin: 0 auto 10px;
            background-size: 40px auto;
            background-position: center;
            background-repeat:no-repeat;
            transition: all .3s ease;
            @media (max-width: 680px) {
              width: 34px; height: 34px;
              background-size: 30px;
              margin-bottom: 6px;
            }
            &.veryDisappointed{
              background-image: url(../assets/verysad.png);
            }
            &.disappointed{
              background-image: url(../assets/sad.png);
            }
            &.moderate{
              background-image: url(../assets/moderate.png);
            }
            &.happy{
              background-image: url(../assets/happy.png);
            }
            &.veryHappy{
              background-image: url(../assets/veryhappy.png);
            }
            &.star{
              background-image: url(../assets/star.png);
              background-size: 38px auto;
              @media (max-width: 680px) {
                background-size: 30px auto;
              }
            }
          }
          h4{
            margin: 0;
            font-size: 14px;
            opacity: .75;
            @media (max-width: 680px) {
              font-size: 12px;
            }
          }
          &.selected{
            background-color: #eaffcf;
            border-color: #78C90E;
            &.starItem{
              background-color: transparent;
              border-color: transparent;
            }
            .happyIcon.star{
              background-image: url(../assets/star-filled-orange.png);
            }
          }
          &.blink{
            animation: blink .3s ease;
          }
          &:hover{
            .happyIcon{
              transform: scale(1.1);
            }
          }
        }
      }
    }
    .checkCnt{
      margin: 20px 0 6px;
      position: relative;
      padding-left: 28px;
      cursor: pointer;
      p{
        color: red;
      }
      .checkboxOuter{
        position: absolute;
        left: -8px; top: -6px;
        width: 32px; height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover{
          background-color: #eee;
        }
        .checkbox{
          width: 14px; height: 14px;
          border-radius: 3px;
          border: #999 2px solid;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .2s ease;
          &.checked{
            border-color: red !important;
            background-color: red !important;
            background-image: url(../assets/checked.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
            .checkInner{
            }
          }
        }
      }
      &:hover{
        .checkboxOuter{
          .checkbox{
            border-color: #444;
          }
        }
      }
    }
    .modalAction{
      margin: 0 -40px -30px;
      padding: 0 30px 20px;
      text-align: right;
      .btn{
        margin-left: 10px;
        padding-top: 8px; padding-bottom: 6px;
        font-size: 16px;
        height: 44px;
      }
      @media (max-width: 680px) {
        margin: 0 -30px -30px;
        padding: 0px 20px 20px;
      }
    }
  }
}
</style>
